import { loginObj } from '@/services/base';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['customer_insights']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var BASE = '/customer_insights/somos1/user_region_access';
export default {
  list: function list() {
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/list"), {
      login: login
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  listByEmail: function listByEmail(email) {
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/list_by_email"), {
      login: login,
      email: email
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  listByRegion: function listByRegion(id_region) {
    var login = loginObj();
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/list_by_region"), {
      login: login,
      id_region: id_region
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  create: function create(email, id_region) {
    var login = loginObj();
    var user_create = window.userInfo && window.userInfo.email ? window.userInfo.email : '';
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/create"), {
      login: login,
      email: email,
      id_region: id_region,
      user_create: user_create
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update: function update(id_user_region_access, email, id_region) {
    var login = loginObj();
    var update_user = window.userInfo && window.userInfo.email ? window.userInfo.email : '';
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/update"), {
      login: login,
      id_user_region_access: id_user_region_access,
      email: email,
      id_region: id_region,
      update_user: update_user
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  delete: function _delete(id_user_region_access) {
    var login = loginObj();
    var delete_user = window.userInfo && window.userInfo.email ? window.userInfo.email : '';
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(BASE, "/delete"), {
      login: login,
      id_user_region_access: id_user_region_access,
      delete_user: delete_user
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};